import { render, staticRenderFns } from "./EventModule.vue?vue&type=template&id=b109eb6a&scoped=true"
import script from "./EventModule.vue?vue&type=script&lang=js"
export * from "./EventModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b109eb6a",
  null
  
)

export default component.exports